import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { ContentView, EnrichedContent } from '../../../../api/client'
import { getClassifiersToDisplay } from '../../../../util/classifierListUtils'
import ContentMetadataAuthor from './ContentMetadataAuthor'
import ContentMetadataClassification from './ContentMetadataClassification'
import ContentMetadataDetails from './ContentMetadataDetails'
import ContentMetadataPostDetails from './ContentMetadataPostDetails'
import { downloadMetadataAsText } from './formatMetadataAsText'
import Button from '../../../Button'

type Props = {
    content: ContentView
    enrichedContent: EnrichedContent | undefined
}

/**
 * Inline panel displaying content metadata. Same content as ContentMetadataModal
 * but rendered as a card rather than a modal dialog.
 */
export default function ContentMetadataPanel({ content, enrichedContent }: Props) {
    const classifiersToDisplay = getClassifiersToDisplay(content)

    const contributingClassifications = [
        ...classifiersToDisplay.relevantSevereClassifications,
        ...classifiersToDisplay.relevantSuspectClassifications
    ]

    return (
        <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="flex items-center gap-3 border-b border-gray-200 px-6 py-4">
                <InformationCircleIcon className="h-6 w-6 text-gray-700" />
                <h2 className="font-sans !font-medium text-lg text-ink-900">Content metadata</h2>
                <div className="ml-auto">
                    <Button
                        text="Download"
                        primary={false}
                        onClick={() =>
                            downloadMetadataAsText({
                                content,
                                enrichedContent,
                                moderation: content.moderation,
                                classifications: contributingClassifications
                            })
                        }
                    />
                </div>
            </div>
            <div className="px-6 py-4 space-y-4">
                <ContentMetadataAuthor content={content} />
                <ContentMetadataDetails enrichedContent={enrichedContent} content={content} />
                <ContentMetadataPostDetails content={content} />
                <ContentMetadataClassification
                    moderation={content.moderation}
                    severeClassifications={classifiersToDisplay.relevantSevereClassifications}
                    suspectClassifications={classifiersToDisplay.relevantSuspectClassifications}
                    accountId={content.account.id}
                    contentId={content.id}
                />
            </div>
        </div>
    )
}
